import React, { useState } from 'react';
import {
  Button, Center, Paper, PasswordInput, Stack, Text, Title,
} from '@mantine/core';

// Wordt getoond wanneer de gebruiker via de resetlink uit de e-mail komt
// (?reset=<token>). Na succes gaat de gebruiker terug naar het loginscherm.
export default function WachtwoordResetPage({ token, onKlaar }) {
  const [wachtwoord, setWachtwoord] = useState('');
  const [herhaal, setHerhaal] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [gelukt, setGelukt] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (wachtwoord !== herhaal) {
      setError('De wachtwoorden komen niet overeen');
      return;
    }
    setLoading(true);
    setError('');
    try {
      const response = await fetch('/api/wachtwoord-reset', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token, nieuw_wachtwoord: wachtwoord }),
      });
      const data = await response.json();
      if (data.success) setGelukt(true);
      else setError(data.error || 'Reset mislukt');
    } catch {
      setError('Netwerkfout');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Center
      style={{
        minHeight: '100vh',
        background: 'linear-gradient(135deg, #e8f8ef 0%, #d0efdd 100%)',
      }}
    >
      <Paper component="form" p="xl" shadow="md" radius="md" withBorder
        style={{ width: 380, maxWidth: '90vw' }} onSubmit={handleSubmit}>
        <Stack gap="md">
          <Title order={2} c="groen.7" ta="center">Nieuw wachtwoord</Title>

          {gelukt ? (
            <>
              <Text size="sm" ta="center">
                Je wachtwoord is gewijzigd. Je kunt nu inloggen.
              </Text>
              <Button fullWidth onClick={onKlaar}>Naar inloggen</Button>
            </>
          ) : (
            <>
              <PasswordInput
                label="Nieuw wachtwoord"
                description="Minimaal 8 tekens"
                value={wachtwoord}
                onChange={e => setWachtwoord(e.currentTarget.value)}
                autoComplete="new-password"
                autoFocus
                required
              />
              <PasswordInput
                label="Herhaal wachtwoord"
                value={herhaal}
                onChange={e => setHerhaal(e.currentTarget.value)}
                autoComplete="new-password"
                required
              />
              {error && <Text c="red" size="sm">{error}</Text>}
              <Button type="submit" loading={loading} fullWidth
                disabled={wachtwoord.length < 8}>
                Wachtwoord instellen
              </Button>
            </>
          )}
        </Stack>
      </Paper>
    </Center>
  );
}
